<template>
    <div
        :style="{
            height: `${size}px`,
            width: `${size}px`,
        }"
        class="loader-wrapper"
    >
        <div
            v-if="value"
            :class="['loader', light ? 'light' : '']"
            :style="{
                height: `${size}px`,
                width: `${size}px`,
            }"
        >
            <div />
            <div />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                default: true,
            },
            light: {
                type: Boolean,
                default: false,
            },
            size: {
                type: Number,
                default: 80,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .loader-wrapper {
        display: inline-block;
    }

    .loader {
        position: relative;
        &.light {
            & > div {
                background-color: $white;
            }
        }
        & > div {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-color: $blue-primary;
            opacity: 0.6;
            position: absolute;
            top: 0;
            left: 0;
            animation: sk-bounce 2s infinite ease-in-out;

            &:last-child {
                animation-delay: -1s;
            }
        }
    }

    @keyframes sk-bounce {
        0%,
        100% {
            transform: scale(0);
        }
        50% {
            transform: scale(1);
        }
    }
</style>
